/* https://simplesinovacao.com */
/* Developed by Guilherme: https://guilhermerocha.dev.br/ */

function createSliders(){
	const swiperStripe = new Swiper('.swiper.stripe-home', {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }, 
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        }
      },
    });
    
    const swiperCollections = new Swiper('.swiper.collections-home', {
	    slidesPerView: 2.3,
	    spaceBetween: 8,
	    breakpoints: {
	        768: {
	            slidesPerView: 5,
	            spaceBetween: 30,
	        },
	        1025: {
	            slidesPerView: 7,
	            spaceBetween: 30,
	        }
	    },
	});

	const swiperMetafieldsProductPage = new Swiper('product-info .hidden-desktop .product_metafields .swiper', {
	    slidesPerView: 2,
	    spaceBetween: 15,
	    breakpoints: {
	        1024: {
	            slidesPerView: 2.5,
	            spaceBetween: 10,
	        }
	    },
	});

	let shelfSealLoaded = document.querySelector('.banner-seal-products .products.swiper');
	console.log(shelfSealLoaded)
	const timerSealShelf = setInterval(() => {
		shelfSealLoaded = document.querySelector('.banner-seal-products .products.swiper');
		if(shelfSealLoaded || timerSealShelf >= 3000){
			const swiperProducts = new Swiper('.banner-seal-products .products.swiper', {
				slidesPerView: 1.3,
				spaceBetween: 12,
				navigation: {
					nextEl: '.banner-seal-products .swiper-buttons .next-button',
					prevEl: '.banner-seal-products .swiper-buttons .prev-button',
				},
				breakpoints: {
					768: {
						slidesPerView: 3,
						spaceBetween: 24,
					},
					1025: {
						slidesPerView: 2.1,
						spaceBetween: 24,
					}
				},
			});

			const swiperMetafieldsShelves = new Swiper('.banner-seal-products .product_metafields .swiper', {
				slidesPerView: 2.3,
				spaceBetween: 15,
				breakpoints: {
					1024: {
						slidesPerView: 2.5,
						spaceBetween: 10,
					}
				},
			});
			clearInterval(timerSealShelf);
		}
	}, 50)

	const swiperTitleInit = new Swiper('#home_title_init .swiper', {
		slidesPerView: 1.1,
		spaceBetween: 18,
		freeMode: true
	});

	let shelfLoaded = document.querySelector('motion-list .product_metafields .swiper');
	const timer = setInterval(() => {
		shelfLoaded = document.querySelector('motion-list .product_metafields .swiper');
		if(shelfLoaded || timer >= 3000){
			const swiperMetafieldsShelves = new Swiper('motion-list .product_metafields .swiper', {
				slidesPerView: 2.3,
				spaceBetween: 15,
				breakpoints: {
					1024: {
						slidesPerView: 2.5,
						spaceBetween: 10,
					}
				},
			});
			clearInterval(timer);
		}
	}, 50)
}

function moveBreadcrumbs(){
	if(document.querySelector("body.template-collection")){
		const breadcrumbsNav = document.querySelector('nav.breadcrumb');
		let slider = document.querySelector("main slideshow-element .flickity-slider");
		const collectionMainBanner = document.querySelector(".collection-main-banner .breadcrumbs-collection");

		if(collectionMainBanner){
			collectionMainBanner.prepend(breadcrumbsNav);
		} else{
			let timer = setInterval(() => {
				slider = document.querySelector("main slideshow-element .flickity-slider");
				
				if(slider && breadcrumbsNav && !slider.contains(breadcrumbsNav)){
					breadcrumbsNav.classList.add("collection", "loaded");
					slider.prepend(breadcrumbsNav);
		
					clearInterval(timer);
				}
			}, 100);
		}
	}
}

async function copyTextToClipboard(text) {
	try {
		await navigator.clipboard.writeText(text);
		
		return true;
	} catch (err) {
		console.error('Failed to copy text: ', err);
	}
}

function btnCouponFunction(){
	const btnCoupon = document.querySelector('.btn-coupon');

	if(btnCoupon){
		const coupon = btnCoupon.value;
		const textContent = btnCoupon.textContent;
		btnCoupon.addEventListener('click', () => {
			const contentToCopy = btnCoupon.value;
			const resp = copyTextToClipboard(contentToCopy);
			
			if(resp){
				btnCoupon.textContent = "Cupom copiado ✅️";
				
				setTimeout(function() {
					btnCoupon.textContent = textContent;
				}, 4000);
			}
		});	
	}
}

function moveElementsMobile(){
	const shopTheFeedSection = document.querySelectorAll('.shop-the-feed-section');
	
	shopTheFeedSection.forEach(section => {
		const btn = section.querySelector('.social-account:has(.btn-coupon)');
		const slider = section.querySelector('slider-element');
		
		if(btn && slider){
			slider.insertAdjacentElement("afterend", btn);
		}
	})
	
	const productInfo = document.querySelector('body.template-product .product__info');
	
	if(productInfo){
		const metafieldsMobile = productInfo.querySelector('.hidden-desktop .product_metafields');
		
		const variantSelects = productInfo.querySelector('variant-selects');
		
		if(metafieldsMobile && variantSelects){
			variantSelects.insertAdjacentElement("afterend", metafieldsMobile);
		}
	}
}

$(document).ready(function() {
	createSliders();
	moveBreadcrumbs();
	btnCouponFunction();

	if(window.screen.availWidth <= 1024){
		moveElementsMobile();	
	}
});

window.addEventListener("scroll", () => {
	moveBreadcrumbs();
})

function stopGoingToCheckout(){
	const checkoutButtons = document.querySelectorAll('shopify-accelerated-checkout, shopify-buy-it-now-button, .shopify-payment-button__button, #minicart-btn-checkout, button[name="checkout"]');

	checkoutButtons.forEach(btn => {
		btn.onclick = function(e) {
			e.preventDefault();
			e.stopPropagation();
	        document.querySelector('.btn-whats-fixed a').click();
	    };
	})
}

window.addEventListener("load", () => {
	stopGoingToCheckout();
	
	(function(ns, fetch) {
	  if (typeof fetch !== 'function') return;
	
	  ns.fetch = function() {
	    var out = fetch.apply(this, arguments);
	    
	    // side-effect
	    out.then(({ ok }) => {
	        //console.log('Requisição carregada', ok);
	        if(
	        	arguments[0]?.indexOf("/products/") !== -1 ||
	        	arguments[0]?.indexOf("/cart/change") !== -1
        	){
	        	setTimeout(function() {
	        		stopGoingToCheckout();
	        	}, 1000);
	        }
	        
	        
	    });
	    
	    return out;
	  }
	
	}(window, window.fetch))
})